<!--
 * @Description: 
 * @Author: 
 * @Date: 2023-09-21 12:30:57
 * @LastEditTime: 2024-03-19 18:54:23
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="right-box-div">
    <div class="title-box01">
      <div class="title-box02">
        <div class="title-name">赛马比拼</div>
        <!-- <table class="table_data01">
          <tr>
            <td>总收入：</td>
            <td colspan="3" class="font02">123653元</td>
          </tr>
          <tr>
            <td>收入渠道数：</td>
            <td colspan="3" class="font02">5个</td>
          </tr>
          <tr>
            <td>收入最多渠道</td>
            <td class="font05">渠道A(56%)</td>
            <td>收入最少渠道</td>
            <td class="font04">渠道C(2.8%)</td>
          </tr>
          <tr>
            <td>渠道A收入</td>
            <td class="font6">53602元</td>
            <td>渠道A收入占比</td>
            <td class="font6">4.8%</td>
          </tr>
          <tr>
            <td>渠道B收入</td>
            <td class="font6">53602元</td>
            <td>渠道B收入占比</td>
            <td class="font6">4.8%</td>
          </tr>
          <tr>
            <td>渠道C收入</td>
            <td class="font6">53602元</td>
            <td>渠道D收入占比</td>
            <td class="font6">4.8%</td>
          </tr>
        </table> -->
        <div id="myline" style="width: 96%;  height: 300px"></div>

        <!-- 条形图 -->
        <div class="mar-t-10">
          <div
            id="mypai"
            style="width: 96%;  height: calc(100vh - 430px)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mianIndex",
  props: {
    // msg: String,
  },
  data() {
    return {
      emphasisStyle: {
        itemStyle: {
          shadowBlur: 10,
          shadowColor: "rgba(0,0,0,0.3)"
        }
      },

      data1: [],
      data2: []
      // data3: [],
      // data4: [],
    };
  },
  mounted() {
    this.getCharts();
    this.getMyLineCharts();
  },
  methods: {
    getCharts() {
      let that = this;
      const chartBox = this.$echarts.init(document.getElementById("mypai"));
      let barTopColor = ["#E8C50B", "#0CD7E2", "#1EAAFE", "#48C3E5", "#FF7317"];
      let barBottomColor = [
        "rgba(232, 197, 11,0.2)",
        "rgba(12, 215, 226, 0.1)",
        "rgba(30, 170, 254, 0.1)",
        "rgba(255,255,255,0.1)",
        "rgba(255,115,23,0.1)"
      ];
      const option = {
        title: {
          text: "规上服务业营业收入TOP5",
          left: "center",
          textStyle: {
            color: "#e9ebee",
            fontSize: "16"
          },

          subtextStyle: {
            color: "#e9ebee",
            fontSize: "16"
          }
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0,0,0,.6)",
          borderColor: "rgba(147, 235, 248, .8)",
          textStyle: {
            color: "#FFF"
          },
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          },

          formatter: function(data) {
            // 添加单位
            var result = data[0].name + "<br>";
            let params = [data[0]];
            console.log(params);
            params.forEach(function(item) {
              if (item.value) {
                result +=
                  item.marker +
                  " " +
                  item.seriesName +
                  " : " +
                  item.value +
                  "万元</br>";
              } else {
                result += item.marker + " " + item.seriesName + " :  - </br>";
              }
            });
            console.log(result);
            return result;
          }
        },
        legend: {
          show: false
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: [
            "宏仁医院",
            "合瑞运输",
            "合州医院",
            "诚顺物业",
            "瞬立达人力资源咨询"
          ],
          axisLabel: {
            formatter: function(value) {
              var result = "";
              var maxLength = 5; // 每行最多显示3个字符
              for (var i = 0, len = value.length; i < len; i += maxLength) {
                result += value.slice(i, i + maxLength) + "\n";
              }
              return result;
            },
            interval: 0, //横轴信息全部显示
            show: true,

            textStyle: {
              color: "#fff"
            }
          }
          // boundaryGap: [0, 0.01]
        },
        yAxis: {
          name: "单位：万元",
          nameTextStyle: {
            //y轴上方单位的颜色
            color: "#83bff6"
          },
          type: "value",
          boundaryGap: [0, 0.01],
          min: 0,
          max: 6000,
          interval: 1000,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff"
            }
          }
          // data: [
          //   "重庆合川燃气有限责任公司",
          //   "重庆市永生食品有限公司",
          //   "重庆宏炜食品有限公司",
          //   "重庆莎公主食品有限公司",
          //   "重庆德炜食品有限公司",
          // ]
        },
        series: [
          // {
          //   name: "2011",
          //   type: "bar",
          //   data: [18203, 23489, 29034, 104970, 131744, 630230]
          // },
          {
            // name: "2023年",
            // type: "bar",
            // data: [23110, 9993, 7872, 6144, 5730]

            name: "2024年",
            type: "pictorialBar",
            symbolSize: [26, 10], // [36, 10],
            symbolOffset: [0, -5], // [0, -5]
            z: 12,
            itemStyle: {
              normal: {
                color: function(params) {
                  return barTopColor[params.dataIndex];
                }
              }
            },
            label: {
              show: true,
              position: "top",
              fontSize: 14,
              fontFamily: "tenxu",
              formatter: "{c}"
            },
            symbolPosition: "end",
            data: [4651, 2231, 1630, 1370, 1305]
          },
          {
            // name: "2023年",
            type: "pictorialBar",
            symbolSize: [26, 10], // [36, 10]
            symbolOffset: [0, 5], // [0, 5]
            z: 12,
            itemStyle: {
              normal: {
                color: function(params) {
                  return barTopColor[params.dataIndex];
                }
              }
            },
            data: [4651, 2231, 1630, 1370, 1305]
          },
          {
            // name: "第一圈",
            type: "pictorialBar",
            symbolSize: [46, 16], // [56, 16]
            symbolOffset: [0, 11], // [0, 11]
            z: 11,
            itemStyle: {
              normal: {
                color: function(params) {
                  return barTopColor[params.dataIndex];
                },
                opacity: 0.2
              }
            },
            data: [4651, 2231, 1630, 1370, 1305]
          },
          {
            name: "第二圈",
            type: "pictorialBar",
            symbolSize: [64, 22], // [74, 22]
            symbolOffset: [0, 17], // [0, 17]
            z: 10,
            itemStyle: {
              normal: {
                color: function(params) {
                  return barTopColor[params.dataIndex];
                },
                opacity: 0.1
              }
            },
            data: [4651, 2231, 1630, 1370, 1305]
          },
          {
            type: "bar",
            itemStyle: {
              normal: {
                // 中间柱子渐变色
                color: function(params) {
                  return new that.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 1,
                      color: barTopColor[params.dataIndex]
                    },
                    {
                      offset: 0,
                      color: barBottomColor[params.dataIndex]
                    }
                  ]);
                },
                opacity: 0.8
              }
            },
            z: 16,
            silent: true,
            barWidth: 26,
            barGap: "-100%",

            data: [4651, 2231, 1630, 1370, 1305]
          }
        ]
      };
      chartBox.setOption(option);
      // 根据页面大小自动响应图表大小
      window.addEventListener("resize", function() {
        chartBox.resize();
      });
    },

    getMyLineCharts() {
      const chartBox = this.$echarts.init(document.getElementById("myline"));
      const option = {
        title: {
          text: "限上商贸企业营业额TOP5",
          textStyle: {
            color: "#e9ebee",
            fontSize: "16"
          }
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0,0,0,.6)",
          borderColor: "rgba(147, 235, 248, .8)",
          textStyle: {
            color: "#FFF"
          },
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          },

          formatter: function(params) {
            // 添加单位
            var result = params[0].name + "<br>";
            params.forEach(function(item) {
              if (item.value) {
                if (item.seriesName == "营业额总计") {
                  result +=
                    item.marker +
                    " " +
                    item.seriesName +
                    " : " +
                    item.value +
                    "万元</br>";
                } else {
                  result +=
                    item.marker +
                    " " +
                    item.seriesName +
                    " : " +
                    item.value +
                    "%</br>";
                }
              } else {
                result += item.marker + " " + item.seriesName + " :  - </br>";
              }
            });
            return result;
          }
        },
        // 图例
        legend: {
          data: ["1-2月增幅", "营业额总计"],
          textStyle: {
            color: "#B4B4B4"
          },
          right: "0",
          top: "6%"
        },
        grid: {
          left: "15%",
          right: "15%",
          bottom: "10%",
          top: "25%"
        },
        xAxis: {
          data: ["中国石油", "臻沣商贸", "国泰生化", "畅谷医药", "丰赢化肥"],
          axisLabel: {
            formatter: function(value) {
              var result = "";
              var maxLength = 4; // 每行最多显示3个字符
              for (var i = 0, len = value.length; i < len; i += maxLength) {
                result += value.slice(i, i + maxLength) + "\n";
              }
              return result;
            },
            interval: 0, //横轴信息全部显示
            show: true,
            textStyle: {
              color: "#fff"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#B4B4B4"
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: [
          // Y轴左边
          {
            name: "营业额总计(万元)",
            nameTextStyle: {
              //y轴上方单位的颜色
              color: "#83bff6"
            },
            splitLine: { show: false },
            min: 0,
            max: 14000,
            interval: 2000,
            axisLine: {
              lineStyle: {
                color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#2378f7" },
                  { offset: 0.7, color: "#2378f7" },
                  { offset: 1, color: "#188df0" }
                ])
              }
            },
            axisLabel: {
              formatter: "{value}",
              textStyle: {
                color: "#fff",
                fontSize: "12"
              }
            }
          },
          // Y轴右边
          {
            type: "value",
            name: "1-2月增幅",
            min:-20,
            max: 3000,
            interval: 300,
            axisLine: {
              lineStyle: {
                color: "#F02FC2"
              }
            },
            axisLabel: {
              formatter: "{value}%",
              textStyle: {
                color: "#fff",
                fontSize: "12"
              }
            }
          }
        ],

        series: [
          {
            name: "1-2月增幅",
            type: "line",
            smooth: true,
            showAllSymbol: true,
            symbol: "emptyCircle",
            symbolSize: 8,
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: "#F02FC2"
              }
            },
            data: [3.24, 215.59, -8.39, 272.53, -5.35]
          },
          {
            name: "营业额总计",
            type: "bar",
            barWidth: "20rem",
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(0,244,255,1)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(0,77,167,1)" // 100% 处的颜色
                    }
                  ],
                  false
                ),
                barBorderRadius: [30, 30, 30, 30],
                shadowColor: "rgba(0,160,221,1)",
                shadowBlur: 4
              }
            },

            data: [12910, 7388, 1735, 1415, 1226]
          }
        ]
      };
      chartBox.setOption(option);
      // 根据页面大小自动响应图表大小
      window.addEventListener("resize", function() {
        chartBox.resize();
      });
    }
  }
};
</script>

<style scoped>
.right-box-div {
  width: 26%;
}

.title-name {
  width: 44%;
  height: 4%;
  margin: 0 auto;
  font-size: 1em;
  color: #ffffff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table_data01 {
  width: 96%;
  margin-left: 2%;
  border-collapse: collapse;
  color: #ffffff;
  margin-top: 10px;
  font-size: 12px;
}

.table_data01 tr td {
  border: 1px solid #5bc0de;
  padding-top: 1.5%;
  padding-bottom: 1.5%;
  text-indent: 3px;
}

.font02 {
  font-size: 30px;
  color: #e9230d;
}

.font05 {
  color: #e92b23;
  font-size: 18px;
}

.font04 {
  color: #a4e90f;
  font-size: 18px;
}

.font6 {
  font-weight: bold;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/right-box.vue